import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute';

import LogViewerGridLayout from './containers/Grid';

export default function LogViewerLayout() {
  return <Router>
    <PrivateRoute exact path="/settings/log-viewer" component={LogViewerGridLayout} />
  </Router>;
}
